import { render, staticRenderFns } from "./hotHotel.vue?vue&type=template&id=60baa704&scoped=true"
import script from "./hotHotel.vue?vue&type=script&lang=js"
export * from "./hotHotel.vue?vue&type=script&lang=js"
import style0 from "./hotHotel.vue?vue&type=style&index=0&id=60baa704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60baa704",
  null
  
)

export default component.exports